import { render, staticRenderFns } from "./myHappyBean.vue?vue&type=template&id=3f65b916&scoped=true&"
import script from "./myHappyBean.vue?vue&type=script&lang=js&"
export * from "./myHappyBean.vue?vue&type=script&lang=js&"
import style0 from "./myHappyBean.vue?vue&type=style&index=0&id=3f65b916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65b916",
  null
  
)

export default component.exports